import React from "react";
import Currencies from "../../modules/currencies";

const CurrenciesPage = () => {
  return <Currencies />;
};

export default CurrenciesPage;
